import styled from 'styled-components'

const Heading2 = styled.h3`
  color: ${({ theme }) => theme.colors.slate};
  font-size: 14px;
  font-weight: 600;
  margin: 0;
`

export default Heading2
